<template>
  <span
    v-if="data"
    class="account-balance__table-user"
    @click="$emit('click', data)"
  >
    <img
      v-if="data.avatar"
      class="account-balance__table-user-avatar"
      alt=""
      :src="data.avatar"
    >

    <span
      v-else
      class="account-balance__table-user-avatar"
    >
      {{ prepareUserInitials(data.name) }}
    </span>

    <span class="account-balance__table-user-name">
      {{ data.name }}
    </span>
  </span>
</template>

<script>
  export default {
    name: 'AccountBalanceTableUserItem',

    props: ['data'],

    methods: {
      prepareUserInitials(name) {
        let result = name[0];
        if (name.includes(' ')) result += name.split(' ')[1][0];
        else result += name[1];

        return result.toUpperCase();
      }
    }
  };
</script>
